import { z } from 'zod';

export const passwordSchema = z
    .object({
        current_password: z.string().min(1, 'Please enter your current password!'),
        password: z
            .string()
            .min(6, 'Password must be at least 6 characters!')
            .max(48, 'Password must be less than 48 characters!'),
        password_confirmation: z.string().min(1, 'Please enter a matching password!'),
    })
    .refine(data => data.password === data.password_confirmation, {
        message: "Your passwords don't match.",
        path: ['password_confirmation'],
    });

export type PasswordFormData = z.infer<typeof passwordSchema>;
